import { render, staticRenderFns } from "./energy.vue?vue&type=template&id=8d245d6c&scoped=true&"
import script from "./energy.vue?vue&type=script&lang=js&"
export * from "./energy.vue?vue&type=script&lang=js&"
import style0 from "./energy.vue?vue&type=style&index=0&id=8d245d6c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d245d6c",
  null
  
)

export default component.exports